import React from 'react';
// import PointLoginLogo from './../../../resources/RTCC/point_club_logo.jpg'
export const InputText = (props) => {
    return (
        <input
            id={props.id}
            type={props.type}
            className={props.className}
            placeholder={props.placeholder}
            maxLength={props.maxLength}
            value={props.value}
            onChange={props.onChange}
            disabled={props.disabled}
            max={props.max}
            min={props.min}
            tabIndex={props.tabIndex}
        />
    );
}